import { Text } from '@chakra-ui/react'
import React from 'react'

export default function Description({text}) {
  return (
    <Text p={2} dangerouslySetInnerHTML={{__html:text}}>
    </Text>
  )
}
